module.exports = __webpack_public_path__ + "img/l.1a5fc063.jpg";